import { Link } from 'react-router-dom';
import { Comic } from '@/mocks/comics';

interface HotComicsProps {
  comics: Comic[];
}

export default function HotComics({ comics }: HotComicsProps) {
  const formatViews = (views: number): string => {
    if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
    return views.toString();
  };

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
      {comics.map((comic, index) => (
        <Link
          key={comic.id}
          to={`/comic/${comic.id}`}
          className="group cursor-pointer"
        >
          <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
            <img
              src={comic.coverImage}
              alt={`${comic.title} - 韩漫免费在线阅读`}
              title={`${comic.title} - 韩漫网`}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              loading="lazy"
            />
            {index < 3 && (
              <div className="absolute top-2 left-2 w-6 h-6 rounded-full bg-primary-500 flex items-center justify-center">
                <span className="text-xs font-bold text-white">{index + 1}</span>
              </div>
            )}
            <div className="absolute top-2 right-2">
              <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${
                comic.status === '连载中'
                  ? 'bg-accent-500/90 text-white'
                  : 'bg-foreground-500/80 text-white'
              }`}>
                {comic.status}
              </span>
            </div>
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent p-3">
              <div className="flex items-center gap-1">
                <div className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-star-fill text-xs text-accent-400"></i>
                </div>
                <span className="text-xs text-white font-medium">{comic.rating}</span>
                <span className="text-xs text-white/50 ml-auto">{formatViews(comic.views)}人阅读</span>
              </div>
            </div>
          </div>
          <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
            {comic.title}
          </h3>
          <p className="text-xs text-foreground-500 mt-0.5">{comic.author}</p>
        </Link>
      ))}
    </div>
  );
}